var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"our-file"},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),_c('input',{ref:"fileInput",attrs:{"accept":_vm.accept,"type":"file"},on:{"change":_vm.fileSelected}})])
}
var staticRenderFns = []

export { render, staticRenderFns }